import {useContext, useEffect} from 'react';
import {Outlet, useParams, Navigate} from 'react-router-dom';
import {NetworkContext} from '../lib/context';

type RevisionIDParam = {
    revisionId: string
}

export function RevisionIDWrapper() {
    const {revisionId} = useParams<RevisionIDParam>();
    const networkOptimizationStore = useContext(NetworkContext);

    // Set revisionId and check for existing streams when it changes
    useEffect(() => {
        if (revisionId && !isNaN(Number(revisionId))) {
            networkOptimizationStore.revisionId = Number(revisionId);
            // Check for existing streams after revisionId is set
            // This handles cases where user navigates to a different revision
            networkOptimizationStore.checkForExistingStreams();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [revisionId]);

    if (!revisionId || isNaN(Number(revisionId)))
        return <Navigate to="/network-optimization/my-files" replace />;

    return <Outlet />;
}